import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StepsWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 600px;
  position: relative;
`

const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  cursor: pointer;
`

const Circle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ isActive }) => (isActive ? '#6967D7' : '#d3d3d3')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#000')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  z-index: 2;
`

const BarWrapper = styled.div`
  flex: 1;
  height: 3px;
  background-color: #d3d3d3;
  display: flex;
  align-items: center;
  position: relative;
`

const Bar = styled.div`
  height: 3px;
  background-color: ${({ isFilled }) => (isFilled ? '#6967D7' : '#d3d3d3')};
  width: 100%;
`

const ProgressSteps = ({ currentStep, setCurrentStep, totalSteps }) => {
  const handleStepClick = (step) => {
    if (setCurrentStep) {
      setCurrentStep(step)
    }
  }

  return (
    <Wrapper>
      <StepsWrapper>
        {Array.from({ length: totalSteps }, (_, index) => (
          <React.Fragment key={index}>
            <Step onClick={() => handleStepClick(index + 1)}>
              <Circle isActive={index < currentStep}>{index + 1}</Circle>
            </Step>
            {index < totalSteps - 1 && (
              <BarWrapper>
                <Bar isFilled={index < currentStep - 1} />
              </BarWrapper>
            )}
          </React.Fragment>
        ))}
      </StepsWrapper>
    </Wrapper>
  )
}

export default ProgressSteps
